<div
  class="asset-img"
  [@hasToGrow]="hasToGrow()"
  [style.backgroundImage]="'url(' + currentImage + ')'"></div>
